import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { userAuthSlice } from "./reducers/admin.slice";
import { adminApi } from "./rtk-api/admin.api";
import { booksApi } from "./rtk-api/books.api";
import { usersApi } from "./rtk-api/users.api";
import { aiPromptsApi } from "./rtk-api/ai-prompts.api";
import { profilesApi } from "./rtk-api/profiles.api";
import { homeApi } from "./rtk-api/home.api";
import { mediaApi } from "./rtk-api/media.api";
import { mediaUploadApi } from "./rtk-api/media-upload.api";

export const store = configureStore({
  reducer: {
    [userAuthSlice.name]: userAuthSlice.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [booksApi.reducerPath]: booksApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [aiPromptsApi.reducerPath]: aiPromptsApi.reducer,
    [profilesApi.reducerPath]: profilesApi.reducer,
    [homeApi.reducerPath]: homeApi.reducer,
    [mediaApi.reducerPath]: mediaApi.reducer,
    [mediaUploadApi.reducerPath]: mediaUploadApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(adminApi.middleware)
      .concat(booksApi.middleware)
      .concat(usersApi.middleware)
      .concat(aiPromptsApi.middleware)
      .concat(profilesApi.middleware)
      .concat(homeApi.middleware)
      .concat(mediaApi.middleware)
      .concat(mediaUploadApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

